import React from 'react'

const MajorBuilding = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.51 4.5h-6v-1A1.5 1.5 0 0011 2H5.52A1.5 1.5 0 004 3.5v17A1.5 1.5 0 005.52 22h13A1.5 1.5 0 0020 20.5V6a1.5 1.5 0 00-1.49-1.5zm-13 16v-17H11v1H8.51A1.5 1.5 0 007 6v14.5H5.51zm3 0h10V6h-10v14.5zm2-11.5v2A1.5 1.5 0 0012 12.5h3a1.5 1.5 0 001.5-1.5V9A1.5 1.5 0 0015 7.49h-3A1.5 1.5 0 0010.51 9zM12 11h3V9h-3v2zm3 3h-3a1.5 1.5 0 00-1.5 1.5v2A1.5 1.5 0 0012 19h3a1.5 1.5 0 001.5-1.5v-2A1.5 1.5 0 0015 14zm-3 3.52h3v-2h-3v2z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorBuilding
